module.exports = __webpack_public_path__ + "img/768_stores_img8.532ac571.png";